import { render, staticRenderFns } from "./ArticlesItemView.vue?vue&type=template&id=aa6afee0&scoped=true&"
import script from "./ArticlesItemView.vue?vue&type=script&lang=js&"
export * from "./ArticlesItemView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesItemView.vue?vue&type=style&index=0&id=aa6afee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6afee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
